import Repository from '@/repositories/repository'

const HomePageRepository = {
  async getAllHomePageComponents(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '10',
      ...queryParams
    }

    return await Repository('homepage', 'page', params)
  }
}

export default HomePageRepository
